module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-honda.136e595c.png";